module.exports = {
  "country": "HR",
  "artist": "Baby Lasagna",
  "song": "Rim Tim Tagi Dim",
  "year": "2024",
  "place": "2",
  "spotify": "5TswDbxMnxptgFTf6ZxvXQ"
};